import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { fetchAuthSession } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(private router: Router) {}

  async canActivate(): Promise<boolean> {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken;
      
      if (idToken) {
        const payload = JSON.parse(atob(idToken.toString().split('.')[1]));
        const userGroups = payload['cognito:groups'] || [];
        const isGlobalAdmin = userGroups.some((group: string) =>
          group.includes('global-admin') || group.includes('sw-manager') || group.includes('technician-admin')
        );    
        if (isGlobalAdmin) {
          return true;
        } else {
          this.router.navigate(['/app']);
          return false;
        }
      } else {
        this.router.navigate(['/app']);
        return false;
      }
    } catch (error) {
      console.error('Error checking admin permissions:', error);
      this.router.navigate(['/app']);
      return false;
    }
  }
}
